// project imports
import logo from 'assets/images/logo.png';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return <img src={logo} alt="Summa" width={35} height={35} style={{ display: 'block' }} />;
}
